import {callApi, updateStatus} from "../05-utils/commonUtils";
import {getEnv} from "../env";

const ACTIONS = {
  PRODUCTS_LOADING: "PRODUCTS_LOADING",
  PRODUCTS_LOADED: "PRODUCTS_LOADED",
  PRODUCTS_LOAD_FAILED: "PRODUCTS_LOAD_FAILED",
  FEATURED_PRODUCTS_LOADING: "FEATURED_PRODUCTS_LOADING",
  FEATURED_PRODUCTS_LOADED: "FEATURED_PRODUCTS_LOADED",
  FEATURED_PRODUCTS_LOAD_FAILED: "FEATURED_PRODUCTS_LOAD_FAILED",
  PRODUCT_ADDING: "PRODUCT_ADDING",
  PRODUCT_ADDED: "PRODUCT_ADDED",
  PRODUCT_ADD_FAILED: "PRODUCT_ADD_FAILED",
  PRODUCT_REMOVING: "PRODUCT_REMOVING",
  PRODUCT_REMOVED: "PRODUCT_REMOVED",
  PRODUCT_REMOVE_FAILED: "PRODUCT_REMOVE_FAILED",
  PRODUCT_UPDATING: "PRODUCT_UPDATING",
  PRODUCT_UPDATED: "PRODUCT_UPDATED",
  PRODUCT_UPDATE_FAILED: "PRODUCT_UPDATE_FAILED",
  PRODUCT_ORDER_SWAPPING: "PRODUCT_ORDER_SWAPPING",
  PRODUCT_ORDER_SWAPPED: "PRODUCT_ORDER_SWAPPED",
  PRODUCT_ORDER_SWAP_FAILED: "PRODUCT_ORDER_SWAP_FAILED",
};

const loadFeaturedProducts = () => {
  let config = {
    method: "post",
    body: {
      isFeatured: true,
    },
  };

  return (dispatch) => {
    dispatch(updateStatus(ACTIONS.FEATURED_PRODUCTS_LOADING));
    callApi(
      getEnv("API_SERVER") + "/product/all",
      config,
      null,
      (data) => {
        dispatch(
          updateStatus(ACTIONS.FEATURED_PRODUCTS_LOADED, {
            products: data.products,
          }),
        );
      },
      (err) => {
        dispatch(
          updateStatus(ACTIONS.FEATURED_PRODUCTS_LOAD_FAILED, {error: err}),
        );
      },
    );
  };
};

const loadProducts = (data) => {
  let config = {
    method: "post",
    body: {
      categoryId: data.categoryId,
      isFeatured: data.isFeatured,
    },
  };

  return (dispatch) => {
    dispatch(updateStatus(ACTIONS.PRODUCTS_LOADING));
    callApi(
      getEnv("API_SERVER") + "/product/all",
      config,
      null,
      (data) => {
        dispatch(
          updateStatus(ACTIONS.PRODUCTS_LOADED, {products: data.products}),
        );
      },
      (err) => {
        dispatch(updateStatus(ACTIONS.PRODUCTS_LOAD_FAILED, {error: err}));
      },
    );
  };
};

const addProduct = (data) => {
  let config = {
    method: "post",
    body: data,
  };

  return (dispatch) => {
    dispatch(updateStatus(ACTIONS.PRODUCT_ADDING, {newProduct: data}));
    callApi(
      getEnv("API_SERVER") + "/product",
      config,
      null,
      (data) => {
        dispatch(
          updateStatus(ACTIONS.PRODUCT_ADDED, {
            _id: data._id,
            img1: data.img1,
            img2: data.img2,
          }),
        );
      },
      (err) => {
        dispatch(updateStatus(ACTIONS.PRODUCT_ADD_FAILED, {error: err}));
      },
    );
  };
};

const deleteProduct = (data) => {
  let config = {
    method: "post",
    body: {_id: data._id},
    headers: {authorization: data.authorization},
  };

  return (dispatch) => {
    dispatch(updateStatus(ACTIONS.PRODUCT_REMOVING, config.body));
    callApi(
      getEnv("API_SERVER") + "/product/remove",
      config,
      null,
      (data) => {
        dispatch(updateStatus(ACTIONS.PRODUCT_REMOVED));
      },
      (err) => {
        dispatch(updateStatus(ACTIONS.PRODUCT_REMOVE_FAILED, {error: err}));
      },
    );
  };
};

const updateProduct = (data) => {
  let config = {
    method: "post",
    body: data,
    headers: {authorization: data.authorization},
  };

  return (dispatch) => {
    dispatch(updateStatus(ACTIONS.PRODUCT_UPDATING, data));
    callApi(
      getEnv("API_SERVER") + "/product/update",
      config,
      null,
      (data) => {
        dispatch(updateStatus(ACTIONS.PRODUCT_UPDATED, data));
      },
      (err) => {
        dispatch(updateStatus(ACTIONS.PRODUCT_UPDATE_FAILED, {error: err}));
      },
    );
  };
};

const swapProductOrders = (data) => {
  let config = {
    method: "post",
    json: true,
    body: {id1: data.id1, id2: data.id2},
    headers: {authorization: data.authorization},
  };

  return (dispatch) => {
    dispatch(updateStatus(ACTIONS.PRODUCT_ORDER_SWAPPING, data));
    callApi(
      getEnv("API_SERVER") + "/product/swap",
      config,
      null,
      () => {
        dispatch(updateStatus(ACTIONS.PRODUCT_ORDER_SWAPPED, data));
      },
      (err) => {
        dispatch(updateStatus(ACTIONS.PRODUCT_ORDER_SWAP_FAILED, {error: err}));
      },
    );
  };
};

export {
  ACTIONS,
  loadProducts,
  addProduct,
  deleteProduct,
  updateProduct,
  loadFeaturedProducts,
  swapProductOrders,
};



// WEBPACK FOOTER //
// ./src/01-actions/adminProducts.js